import {
  MarkdownSourceLimitError,
  MAX_MARKDOWN_SOURCE_BYTES,
} from '@/shared/markdown/limits'

export function acceptMarkdownSource(markdown: string): boolean {
  if (markdown.length > MAX_MARKDOWN_SOURCE_BYTES) return false
  return new TextEncoder().encode(markdown).byteLength <= MAX_MARKDOWN_SOURCE_BYTES
}

export function buildMarkdownExport(markdown: string): string {
  if (!acceptMarkdownSource(markdown)) throw new MarkdownSourceLimitError()
  return markdown
}
